import React from 'react';
import './index.sass';

const Intro = () => {
    return (
        <section className="Intro">
            {/* Плавающие неоновые орбы */}
            <div className="Intro__Aura" aria-hidden="true">
                <span className="Intro__Orb Intro__Orb--violet" />
                <span className="Intro__Orb Intro__Orb--cyan" />
                <span className="Intro__Orb Intro__Orb--pink" />
            </div>

            <div className="Intro__Container container container--slim">
                <div className="Intro__Content">
                    <span className="Intro__Eyebrow">IT-инфраструктура высокой степени зрелости</span>

                    <h1 className="Intro__Title">
                        Создаём сложные <br />
                        <span className="Intro__Title-Grad">информационные системы</span>,<br />
                        которые работают годами
                    </h1>

                    <p className="Intro__Text">
                        Платформы, экосистемы и продукты для банков, госсектора и крупной индустрии.
                        От архитектуры и ядра — до эксплуатации и развития. Берёмся за задачи,
                        которые другие считают неподъёмными.
                    </p>

                    <div className="Intro__Actions">
                        <a href="#projects" className="Intro__Btn Intro__Btn--Primary">
                            Наши проекты
                        </a>
                        <a href="#contacts" className="Intro__Btn Intro__Btn--Ghost">
                            Обсудить задачу
                        </a>
                    </div>

                    <div className="Intro__Stats">
                        <div className="Intro__Stat">
                            <span className="Intro__Stat-Value">15<span className="Intro__Stat-Plus">+</span></span>
                            <span className="Intro__Stat-Label">лет на рынке сложного Enterprise</span>
                        </div>
                        <div className="Intro__Stat-Divider" />
                        <div className="Intro__Stat">
                            <span className="Intro__Stat-Value">50<span className="Intro__Stat-Plus">+</span></span>
                            <span className="Intro__Stat-Label">крупных проектов в эксплуатации</span>
                        </div>
                        <div className="Intro__Stat-Divider" />
                        <div className="Intro__Stat">
                            <span className="Intro__Stat-Value">24/7</span>
                            <span className="Intro__Stat-Label">сопровождение критичных систем</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="Intro__ScrollHint" aria-hidden="true">
                <span className="Intro__ScrollHint-Line" />
            </div>
        </section>
    );
};

export default Intro;
